import script from "./ImportFromApp.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportFromApp.vue?vue&type=script&setup=true&lang=js"

import "./ImportFromApp.vue?vue&type=style&index=0&id=7968833f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7968833f"]])

export default __exports__